document.querySelectorAll('.footer__blocks-wrapper details').forEach(function (item) {
  item.addEventListener('click', function () {
    // close all details
    for (let item of document.querySelectorAll('.footer__blocks-wrapper details[open]')) {
      // keep open only details clicked
      if (this != item) {
        item.removeAttribute('open');
      }
    }
  });

  if (
    window.location.href.includes('form_type=customer') &&
    document.querySelector('.newsletter-form__field-wrapper input').value.length !== 0
  ) {
    document.querySelector('.newsletter-form__message--already-subscribed').classList.remove('hidden');
  }
});
